import { useRef } from "react"
import { useNavigate, useParams } from "react-router-dom"

//api
import { KBService } from "../../../service/kb-service"

//components
import { Toast } from "primereact/toast"
import { Button } from "primereact/button"
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup"

const DeleteKbFile = ()=>{
    const { id } = useParams()
    const navigate = useNavigate()
    const toastDelete = useRef(null)

    const confirmDelete = (event) => {
        confirmPopup({
          target: event.currentTarget,
          message: 'Sei sicuro di voler eliminare questo file?',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Si',
          rejectLabel: 'No',
          acceptClassName: 'p-button-danger',
          accept: handleDelete,
          reject: () => {
            toastDelete.current.show({
              severity: 'info',
              summary: 'Annullato',
              detail: 'Eliminazione annullata.',
              life: 3000,
            })
          },
        })
    }

    const handleDelete = () => {
        KBService.deleteKbFile(id, () => {
          toastDelete.current.show({
            severity: 'success',
            summary: 'Successo',
            detail: 'File eliminato con successo!',
            life: 3000,
          })
          setTimeout(() => {
            navigate('/dashboard/kb')
          }, 1500)
        })
      }
      return (
          <>
            <Toast ref={toastDelete} />
            <ConfirmPopup />
            <Button
              type="button"
              severity="danger"
              className="prompt__DeleteButton"
              onClick={confirmDelete}
            >
              Elimina
            </Button>
          </>
        )
}

export default DeleteKbFile